module.exports = __webpack_public_path__ + "img/Road-bike-left-side.9ffaaaa.svg";